import PrenotazioniComponent from "../../components/Dashboard/Prenotazioni/PrenotazioniComponent";

export default function Dashboard() {


    return (
        <PrenotazioniComponent></PrenotazioniComponent>
    )
}